import { MoreHorizontal } from "lucide-react";
import { useState } from "react";
import { NavLink, useLocation } from "react-router";
import {
	Sheet,
	SheetContent,
	SheetDescription,
	SheetHeader,
	SheetTitle,
	SheetTrigger,
} from "@/components/ui/sheet";
import { allNavItems } from "@/config/nav";
import { cn } from "@/lib/utils";

const primary = allNavItems.filter((i) => i.primary);
const secondary = allNavItems.filter((i) => !i.primary);

const itemClass =
	"flex min-h-14 min-w-11 flex-1 flex-col items-center justify-center gap-0.5 text-[11px] font-medium";

// Phone navigation: four primary screens plus a "More" sheet. 44 px+ targets.
export function BottomNav() {
	const { pathname } = useLocation();
	const [moreOpen, setMoreOpen] = useState(false);
	const moreActive = secondary.some((i) => pathname.startsWith(i.url));

	return (
		<nav
			aria-label="Primary"
			className="bg-background/95 supports-[backdrop-filter]:bg-background/80 fixed inset-x-0 bottom-0 z-30 flex border-t pb-[env(safe-area-inset-bottom)] backdrop-blur md:hidden"
		>
			{primary.map((item) => (
				<NavLink
					key={item.url}
					to={item.url}
					className={({ isActive }) =>
						cn(itemClass, isActive ? "text-primary" : "text-muted-foreground")
					}
				>
					<item.icon className="size-5" />
					{item.title}
				</NavLink>
			))}
			<Sheet open={moreOpen} onOpenChange={setMoreOpen}>
				<SheetTrigger
					className={cn(itemClass, moreActive ? "text-primary" : "text-muted-foreground")}
				>
					<MoreHorizontal className="size-5" />
					More
				</SheetTrigger>
				<SheetContent side="bottom" className="pb-[env(safe-area-inset-bottom)]">
					<SheetHeader>
						<SheetTitle>More</SheetTitle>
						<SheetDescription className="sr-only">Other MOS screens</SheetDescription>
					</SheetHeader>
					<div className="grid grid-cols-3 gap-2 px-4 pb-4">
						{secondary.map((item) => (
							<NavLink
								key={item.url}
								to={item.url}
								onClick={() => setMoreOpen(false)}
								className={({ isActive }) =>
									cn(
										"flex min-h-16 flex-col items-center justify-center gap-1 rounded-lg border text-sm",
										isActive ? "border-primary text-primary" : "text-foreground",
									)
								}
							>
								<item.icon className="size-5" />
								{item.title}
							</NavLink>
						))}
					</div>
				</SheetContent>
			</Sheet>
		</nav>
	);
}
